import { Controller } from "@hotwired/stimulus"

// Panneau « Ajouter des champs » : filtre par libellé, « Tout le bloc » coche les champs libres de
// la catégorie, le bouton n'est actif qu'avec une sélection.
export default class extends Controller {
  static targets = ["row", "group", "box", "submit"]

  filter(event) {
    const text = event.target.value.trim().toLowerCase()
    this.rowTargets.forEach((row) => { row.hidden = text !== "" && !row.dataset.text.includes(text) })
    this.groupTargets.forEach((group) => {
      group.hidden = group.querySelectorAll("[data-fields--form-picker-target='row']:not([hidden])").length === 0
    })
  }

  toggleGroup(event) {
    const group = event.currentTarget.closest("[data-fields--form-picker-target='group']")
    group.querySelectorAll("[data-fields--form-picker-target='row']:not([hidden]) input[name='refs[]']:not(:disabled)").forEach((box) => { box.checked = event.currentTarget.checked })
    this.count()
  }

  count() {
    this.submitTarget.disabled = !this.boxTargets.some((box) => box.checked)
  }
}
